import React from 'react';
import { Link } from 'react-router-dom';
import { MailCheck, ArrowRight, Zap } from 'lucide-react';

// Dodanie importu czcionki Inter
const fontLink = document.createElement('link');
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;900&display=swap';
fontLink.rel = 'stylesheet';
document.head.appendChild(fontLink);

function SubscriptionThankYou() {
  return (
    <div className="bg-black pt-40 text-white min-h-screen flex flex-col items-center justify-center text-center p-6 relative overflow-hidden">
      {/* Dekoracyjne tło */}
      <div className="absolute inset-0 opacity-10 z-0">
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-violet-600/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-violet-700/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
      
      <div className="relative z-10 flex flex-col items-center max-w-3xl">
        <MailCheck className="w-24 h-24 text-violet-600 mb-6" strokeWidth={1.5} />
        <h1 
          className="text-3xl sm:text-5xl md:text-6xl font-black mb-4 uppercase leading-tight"
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 900 }}
        >
          Jesteś na liście!
        </h1>
        <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto">
          Dziękujemy za zaufanie. Sprawdź swoją skrzynkę mailową (również folder SPAM), aby nie przegapić żadnych ważnych informacji o dotacjach.
        </p>

        <div className="w-full mt-4 p-8 backdrop-blur-md bg-white/5 rounded-2xl border border-white/10">
            <h2 className="text-2xl font-bold text-white mb-2">Zanim nadejdzie pierwszy mail...</h2>
            <p className="text-gray-400 mb-6">Zobacz, co jest teraz na topie w świecie dofinansowań:</p>
            <Link 
                to="/dotacje/sciezka-smart"
                className="group w-full max-w-md mx-auto bg-gradient-to-r from-violet-600/10 to-violet-700/10 p-6 rounded-xl border border-violet-600/30 hover:border-violet-600/60 transition-all duration-300 flex items-center gap-6"
            >
                <div className="w-12 h-12 flex-shrink-0 flex items-center justify-center bg-violet-600 text-white rounded-lg">
                    <Zap />
                </div>
                <div className="text-left">
                    <p className="text-sm text-violet-500 font-semibold">FLAGOWY PROGRAM</p>
                    <h3 className="text-xl font-bold text-white">Ścieżka SMART</h3>
                </div>
                <ArrowRight className="w-6 h-6 text-violet-500 ml-auto flex-shrink-0 group-hover:translate-x-1 transition-transform" />
            </Link>
        </div>
        
        <Link 
          to="/" 
          className="mt-12 text-gray-400 hover:text-white transition-colors"
        >
          Wróć na stronę główną
        </Link>
      </div>
    </div>
  );
}

export default SubscriptionThankYou;